import React from "react";
import ServiceLayout from "../../components/services/ServiceLayout";
import { 
  Smile, 
  EyeOff, 
  RotateCcw, 
  Zap, 
  ScanEye, 
  CheckCircle2, 
  Users, 
  ShieldCheck, 
  Layers,
  ScanFace,
  AlignHorizontalDistributeCenter,
  Activity
} from "lucide-react";
// import { Smile, ScanFace, AlignHorizontalDistributeCenter, Activity } from "lucide-react";

import image1 from '../../Assets/Services/Service12-2.jpg'
import image2 from '../../Assets/Services/Service12-3.jpg'


const Invisalign = () => {
    const features = [
  { title: "Tooth Alignment", icon: AlignHorizontalDistributeCenter },
  { title: "Bite Relationship", icon: Activity },
  { title: "Facial Profile", icon: ScanFace },
  { title: "Smile Aesthetics", icon: Smile }
];
  return (
    <ServiceLayout
      title="Invisalign - The Clear Aligner Solution"
      subtitle="Straighten your teeth with confidence. Experience the world's most advanced nearly invisible orthodontic system."
      heroImage="/images/hero/invisalign-hero.jpg"
      images={[image1, image2]}
    >
      {/* 1. Introduction */}
      <section className="mb-12">
        <p className="text-xl text-slate-700 leading-relaxed font-light">
          A well-aligned smile improves both appearance and oral health. Many people hesitate to undergo orthodontic treatment because they do not want visible metal braces. At <strong>Dr. Sridhar International Dental Hospitals</strong>, we offer a more comfortable, aesthetic, and modern solution with <strong>Invisalign</strong>.
        </p>
        <div className="mt-8 flex items-center gap-4 bg-blue-50 p-6 rounded-2xl border border-blue-100">
          <ShieldCheck className="text-blue-600 w-12 h-12 flex-shrink-0" />
          <p className="text-blue-900 font-bold">
            We are Certified Invisalign Providers in Vijayawada and Hyderabad, offering personalized digital smile journeys.
          </p>
        </div>
      </section>

      {/* 2. What is Invisalign - High Tech Section */}
      <section className="mb-16 bg-white border border-slate-100 p-8 md:p-12 rounded-[3rem] shadow-sm">
        <h2 className="text-3xl font-black text-blue-950 mb-6 flex items-center gap-3">
          <ScanEye className="text-blue-600" /> What is Invisalign?
        </h2>
        <p className="text-slate-600 leading-relaxed mb-8">
          Invisalign is a globally recognized orthodontic system that replaces traditional brackets with a series of <strong>custom-made, transparent aligners</strong>. These aligners gradually and gently move your teeth into the correct position based on a precise digital treatment plan.
        </p>
        
        <div className="grid md:grid-cols-3 gap-6">
          <div className="flex flex-col items-center text-center p-6 bg-slate-50 rounded-2xl">
            <Layers className="text-blue-500 mb-3" />
            <h5 className="font-bold text-sm mb-1">Custom Made</h5>
            <p className="text-xs text-slate-500">Designed specifically for your unique tooth structure.</p>
          </div>
          <div className="flex flex-col items-center text-center p-6 bg-slate-50 rounded-2xl">
            <Zap className="text-blue-500 mb-3" />
            <h5 className="font-bold text-sm mb-1">Gently Effective</h5>
            <p className="text-xs text-slate-500">Moves teeth step-by-step with calculated pressure.</p>
          </div>
          <div className="flex flex-col items-center text-center p-6 bg-slate-50 rounded-2xl">
            <EyeOff className="text-blue-500 mb-3" />
            <h5 className="font-bold text-sm mb-1">Nearly Invisible</h5>
            <p className="text-xs text-slate-500">So clear, most people won't even notice you're wearing them.</p>
          </div>
        </div>
      </section>

      {/* 3. Problems Corrected Grid */}
      <section className="mb-16">
        <h2 className="text-2xl font-black text-slate-900 mb-8 px-4 border-l-4 border-blue-600">
          Dental Problems Corrected by Invisalign
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {[
            "Crooked teeth",
            "Crowded teeth",
            "Gaps between teeth",
            "Overbite",
            "Underbite",
            "Crossbite",
            "Mild to moderate bite problems"
          ].map((item, idx) => (
            <div key={idx} className="flex items-center gap-3 p-4 bg-white rounded-xl border border-slate-100 shadow-sm hover:border-blue-200 transition-colors">
              <CheckCircle2 className="text-blue-500 w-5 h-5 flex-shrink-0" />
              <span className="font-semibold text-slate-700 text-sm">{item}</span>
            </div>
          ))}
        </div>
      </section>

      {/* 4. Advantages Ribbon (Dark Background) */}
      <section className="bg-blue-950 text-white p-10 md:p-12 rounded-[4rem] mb-16 shadow-2xl relative overflow-hidden">
        <div className="relative z-10">
          <h2 className="text-3xl font-bold mb-12 text-center !text-blue-100">The Invisalign Advantage</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            
            <div className="flex gap-5">
              <div className="bg-blue-800/50 p-4 rounded-2xl h-fit">
                <RotateCcw className="text-blue-300 w-8 h-8" />
              </div>
              <div>
                <h4 className="text-xl font-bold mb-2 !text-blue-100">Fully Removable</h4>
                <p className="text-sm !text-blue-100 opacity-80 leading-relaxed">Unlike fixed braces, you can remove your aligners to eat your favorite foods and maintain perfect oral hygiene by brushing and flossing normally.</p>
              </div>
            </div>

            <div className="flex gap-5">
              <div className="bg-blue-800/50 p-4 rounded-2xl h-fit">
                <ScanEye className="text-blue-300 w-8 h-8" />
              </div>
              <div>
                <h4 className="text-xl font-bold mb-2 !text-blue-100">Digital Precision</h4>
                <p className="text-sm !text-blue-100 opacity-80 leading-relaxed">We use advanced 3D scanning technology to plan and predict the movement of your teeth, helping us achieve highly accurate results.</p>
              </div>
            </div>

            <div className="flex gap-5">
              <div className="bg-blue-800/50 p-4 rounded-2xl h-fit">
                <Users className="text-blue-300 w-8 h-8" />
              </div>
              <div>
                <h4 className="text-xl font-bold mb-2 !text-blue-100">Perfect for All Ages</h4>
                <p className="text-sm !text-blue-100 opacity-80 leading-relaxed">Adults love it for its discreet look in professional settings, and teenagers prefer it for its comfort during school and sports activities.</p>
              </div>
            </div>

            <div className="flex gap-5">
              <div className="bg-blue-800/50 p-4 rounded-2xl h-fit">
                <ShieldCheck className="text-blue-300 w-8 h-8" />
              </div>
              <div>
                <h4 className="text-xl font-bold mb-2 !text-blue-100">Ultimate Comfort</h4>
                <p className="text-sm !text-blue-100 opacity-80 leading-relaxed">Crafted from smooth SmartTrack material, there are no sharp metal brackets or wires to cause irritation to your gums or cheeks.</p>
              </div>
            </div>

          </div>
        </div>
        {/* Subtle Decorative Icon */}
        <Layers className="absolute -bottom-10 -left-10 w-80 h-80 text-white/5 -rotate-12" />
      </section>

      {/* 5. Treatment Planning Section */}
      <section className="mb-16">
        <h2 className="text-2xl font-black text-slate-900 mb-6 text-center">Our Orthodontic Approach</h2>
        <p className="text-slate-600 text-center max-w-3xl mx-auto mb-10 leading-relaxed">
          At Dr. Sridhar International Dental Hospitals, we don't just move teeth; we design smiles. Our orthodontic team provides a comprehensive analysis before starting your journey.
        </p>
        <div className="space-y-4">

  <p className="text-xs font-black uppercase tracking-widest text-blue-600 text-center">
    Analyzing
  </p>

  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
    {features.map(({ title, icon: Icon }) => (
      <div
        key={title}
        className="p-6 bg-slate-50 border border-slate-100 rounded-3xl text-center"
      >
        <Icon className="mx-auto mb-3 text-blue-600" size={28} />
        <p className="font-bold !text-blue-950">{title}</p>
      </div>
    ))}
  </div>

</div>
      </section>

      {/* 6. Closing Trust Footer */}
      <section className="border-t border-slate-100 pt-12">
        <div className="bg-blue-50 p-8 md:p-12 rounded-[3rem] flex flex-col md:flex-row items-center gap-8">
            <div className="bg-white p-6 rounded-full shadow-xl">
                <Smile className="w-16 h-16 text-blue-600" />
            </div>
            <div>
                <h3 className="text-2xl font-black text-blue-950 mb-4">Start Your Invisalign Journey</h3>
                <p className="text-slate-600 leading-relaxed mb-0">
                    If you are looking for Invisalign treatment in <strong>Vijayawada or Hyderabad</strong>, our team at Dr. Sridhar International Dental Hospitals can help you achieve a straighter and more confident smile with advanced technology and expert care.
                </p>
            </div>
        </div>
      </section>
    </ServiceLayout>
  );
};

export default Invisalign;